export default __webpack_public_path__ + "static/media/img_blanketBase_beige_p.a55acf7d.jpg";